import styled, { css, keyframes } from 'styled-components'

export const StepsGroup = styled.ol`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
`
interface PropsStep {
  type: "current" | "finished" | "disabled";
}

export const Step = styled.li<PropsStep>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => props.theme.step}
  &:last-child {
    margin-right: 0px;
    div:after,
    div:before {
      display: none;
    }
  }
`
interface PropsStepIndicatorWrapper {
  type: string;
}

export const StepIndicatorWrapper = styled.div<PropsStepIndicatorWrapper>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  ${props => props.theme.indicator};

  &:before,
  &:after {
    content: "";
    position: absolute;
    height: 1px;
    left: 100%;
  }
  &:after {
    z-index: 1;
    ${props => props.theme.motion}
    ${props => props.type === 'finished' && css`
      width: 112px;
      ${props => props.theme.line.disabled};
    `}
    ${props => props.type === 'current' && css`
      width: 120px;
      ${props => props.theme.line.disabled};
    `}
    ${props => props.type === 'disabled' && css`
      width: 128px;
      ${props => props.theme.line.disabled};
      left: calc(100% - 8px);
    `}
  }
  &:before {
    width: 0px;
    ${props => props.theme.line.active};
    z-index: 2;
    ${props => props.theme.motion}
    transition-property: width;
  }
  ${props => props.type === 'finished' && css`
    &:before {
      width: 112px;
    }
  `}
`

const stepAnimation = (props: any) => keyframes`
  0% { box-shadow: 0 0 0 0 ${props.shadowColor}; }
  50% { box-shadow: 0 0 0 ${props.shadowWidth} ${props.shadowColor}}
  100% { box-shadow: 0 0 0 0 ${props.shadowColor}; }
`
interface PropsStepIndicator {
  type: string;
}

export const StepIndicator = styled.span<PropsStepIndicator>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  ${props => props.theme.motion}
  ${props => props.theme.indicator[props.type]}

  ${props => props.type === 'current' && css`
    animation-delay: 0.275s;
    animation-name: ${props => stepAnimation(props.theme.indicator.animation)};
    animation-duration: 1s;
    animation-iteration-count: 1;
  `}
  ${props => props.type === 'disabled' && css`
    font-size: 1px;
  `}
`

interface PropsStepLabel {
  type: string;
}

export const StepLabel = styled.span<PropsStepLabel>`
  text-align: center;
  ${props => props.theme.label};
  ${props => props.type === 'disabled' && props.theme.label.disabled}
`

export const StepProgress = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StepProgressBar = styled.progress`
  ${props => props.theme.progress};
  overflow: hidden;
  -webkit-appearance: none;
  width: 100%;
  ${props => props.theme.progress.bar};
  &::-webkit-progress-bar {
    -webkit-appearance: none;
    ${props => props.theme.progress.bar};
  }
  &::-webkit-progress-value {
    -webkit-appearance: none;
    ${props => props.theme.progress.value};
    ${props => props.theme.motion}
  }
  &::-moz-progress-bar {
    -webkit-appearance: none;
    transform-origin: 0 0;
  }
  &::-ms-fill {
    -webkit-appearance: none;
    border:0;
  }
`;

export const StepProgressLabel = styled.span`
  text-transform: uppercase;
  ${props => props.theme.caption};
`;